
import './Technologies.scss'
import '../App.scss'
import { motion } from "framer-motion"
import { useState } from 'react'

function Technologies() {
    const [hoveredTech, setHoveredTech] = useState(null);

    const itemDataBackend = [
        {
            img: '/images/technologies/backend/python.png',
            title: 'python',
        },
        {
            img: '/images/technologies/backend/celery.png',
            title: 'celery',
        },
        {
            img: '/images/technologies/backend/django.png',
            title: 'django',
        },
        {
            img: '/images/technologies/backend/github.png',
            title: 'github',
        },
        {
            img: '/images/technologies/backend/flask.png',
            title: 'flask',
        },
        {
            img: '/images/technologies/backend/drf.png',
            title: 'drf',
        },
        {
            img: '/images/technologies/backend/fastapi.png',
            title: 'fastapi',
        },
        {
            img: '/images/technologies/backend/postgresql.png',
            title: 'postgresql',
        },
        {
            img: '/images/technologies/backend/dynamodb.png',
            title: 'dynamodb',
        },
    ]

    const itemDataFrontend = [
        {
            img: '/images/technologies/frontend/javascript.png',
            title: 'javascript',
        },
        {
            img: '/images/technologies/frontend/react.png',
            title: 'react',
        },
        {
            img: '/images/technologies/frontend/material-ui.png',
            title: 'material',
        },
        {
            img: '/images/technologies/frontend/redux.png',
            title: 'redux',
        },
        {
            img: '/images/technologies/frontend/webpack.png',
            title: 'webpack',
        },
        {
            img: '/images/technologies/frontend/yarn.png',
            title: 'yarn',
        },
    ]

    const itemDataDevOps = [
        {
            img: '/images/technologies/devops/ansible.png',
            title: 'ansible',
        },
        {
            img: '/images/technologies/devops/docker.png',
            title: 'docker',
        },
        {
            img: '/images/technologies/devops/redis.png',
            title: 'redis',
        },
        {
            img: '/images/technologies/devops/sentry.png',
            title: 'sentry',
        },
        {
            img: '/images/technologies/devops/jenkins.png',
            title: 'jenkins',
        },
        {
            img: '/images/technologies/devops/aws-codepipeline.png',
            title: 'codepipeline',
        },
    ]


    const itemDataML = [
        {
            img: '/images/technologies/ml/tensorflow.png',
            title: 'tensorflow',
        },
        {
            img: '/images/technologies/ml/spacy.png',
            title: 'spacy',
        },
        {
            img: '/images/technologies/ml/scikit-learn.png',
            title: 'scikitlearn',
        },
        {
            img: '/images/technologies/ml/sagemaker.png',
            title: 'sagemaker',
        },
        {
            img: '/images/technologies/ml/spark.png',
            title: 'spark',
        },
        {
            img: '/images/technologies/ml/keras.png',
            title: 'keras',
        },
        {
            img: '/images/technologies/ml/xgboost.png',
            title: 'xgboost',
        },
        {
            img: '/images/technologies/ml/pytorch.png',
            title: 'pytorch',
        },
        {
            img: '/images/technologies/ml/pandas.png',
            title: 'pandas',
        },
    ]

    const allTechnologies = [
        ...itemDataML,
        ...itemDataBackend,
        ...itemDataFrontend,
        ...itemDataDevOps
    ];

    return (
        <section id="technologies">
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="technologies-container"
            >
                <h1 className="technologies-heading">Technologies We Use</h1>
                <div className="tech-carousel-wrapper">
                    <div className="tech-carousel">
                        <div className="tech-carousel-track">
                            {[...allTechnologies, ...allTechnologies].map((tech, index) => (
                                <div
                                    key={index}
                                    className="tech-item"
                                    onMouseEnter={() => setHoveredTech(index)}
                                    onMouseLeave={() => setHoveredTech(null)}
                                    onClick={() => setHoveredTech(hoveredTech === index ? null : index)}
                                >
                                    <img
                                        src={tech.img}
                                        alt={tech.title}
                                        className="tech-logo"
                                    />
                                    {hoveredTech === index && (
                                        <div className="tech-tooltip">
                                            {tech.title}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    )
}

export default Technologies